<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    @change="handleChange"
    :loading="loading"
    placeholder="请选择"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option key="0" :value="0" label="请选择" disabled></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
  
<script>
import { campaignList } from '@/service/getData'

export default {
  props: {
    value: '',
    tag: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData() {
      this.loading = true
      let res = await campaignList({
        is_select_option: true,
        tag_id: this.tag,
      })
      this.loading = false
      this.lists = res.data.list
    },
  },
}
</script>